import React, {Component} from 'react';
import {Text, Image as ZyImage,FromToEffect,Video} from "@zhiyun-web/components";
import {CarryEffectAuto,Photography20} from "@zhiyun-web/common-lib-weebill-3s";
import "@zhiyun-web/common-lib-weebill-3s/index.css";

import {Play} from '@zhiyun-web/icons'
import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { TextPlugin } from "gsap/TextPlugin";
import {CustomEase} from "gsap/CustomEase"
import styles from './CraneM3S.module.css'
import {functions} from "@zhiyun-web/helper";

// import Photography20 from "./Photography20";


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(TextPlugin);
gsap.registerPlugin(CustomEase);
const headerRef = React.createRef();

const videoSection5Ref = React.createRef();//控制快拆视频1播放
const videoSection6Ref = React.createRef();//控制快拆视频2播放
const videoSection9Ref = React.createRef();//控制蓝牙视频播放
const videoSection10Ref = React.createRef();//控制闪光灯视频播放
const videoSection11Ref1 = React.createRef();//控制延时摄影视频播放
const videoSection11Ref2 = React.createRef();//控制竖屏拍摄视频播放
const videoSection11Ref3 = React.createRef();//控制盗梦空间视频播放
const videoColorScreenRef = React.createRef();//控制彩屏视频播放
// const videoSection12Ref = React.createRef();//控制续航视频播放
class CraneM3S extends Component {
    constructor(props) {
        super(props);
        this.state = {
            screenWidth:functions.getWidth(),
            section7Dom:'',//承载动画
            section10MovieV2Dom:'',//移动影像2.0
            textData:{},//文案内容
            section11ButtonIndex:0,//当前被中
            isWeiXinPlay:true,//是否微信上自动播放，只适用于微信
        };
        window.addEventListener('resize', this.reLoadGsapFunctions.bind(this));
    }

    componentWillMount() {
        this.getTextData();
    }

    /**
     * 获取组件模块名称
     * @return {string}
     */
    getComponentName(){
        return 'CraneM3S'
    }

    /**
     * 获取文案
     */
    getTextData(){
        let data = functions.getGlobalData(`${this.getComponentName()}_TextData_`+functions.getLanguage());
        if(functions.isNull(data)){
            let api = `https://www.zhiyun-tech.com/website/in18/m3s/${functions.getLanguage()}.json`;
            functions.requestGet(api,{},this.getTextDataFeedback.bind(this));
        }else{
            this.setState({textData:functions.getGlobalData(`${this.getComponentName()}_TextData_`+functions.getLanguage())});
        }
    }

    /**
     * 获取文案后回调
     * @param result
     */
    getTextDataFeedback(result={}){
        if(result['code']===10000){
            return false;
        }
        if(!functions.isNull(result)){//异常
            this.setState({textData:result ?? {}});
            functions.setGlobalData(`${this.getComponentName()}_TextData_`+functions.getLanguage(),result)
        }
    }

    componentDidMount() {
        if(functions.isNull(this.state.textData)){
            let nums = 0;
            let interval = setInterval(()=>{
                if(nums>10){
                    clearInterval(interval);
                }
                if(!functions.isNull(this.state.textData)){
                    this.headerAnimation();
                    this.section3Animation();
                    this.section3LeftImageAnimation();
                    this.section3RightImageAnimation();
                    this.section5Animation();
                    this.section6Animation();
                    // this.section10Animation();
                    this.section10MovieV2();//带其他触发
                    clearInterval(interval);
                }
                nums++;
            },1000);
        }else{
            this.headerAnimation();
            this.section3Animation();
            this.section3LeftImageAnimation();
            this.section3RightImageAnimation();
            this.section5Animation();
            this.section6Animation();

            // this.section10Animation();
            this.section10MovieV2();//带其他触发
        }
    }

    /**
     * 当窗体大小改变时重新加载并计算各种函数
     */
    reLoadGsapFunctions(){
        this.setState({screenWidth:functions.getWidth()});
    }

    //头部动画
    headerCanvasRef = React.createRef();//动画的 canvas 元素
    headerCanvasContext = null;
    headerCanvasImages = [];//画片帧
    headerCanvasFrames = {frame: 0};//动画帧控制

    //搭载动画
    section7CanvasRef = React.createRef();
    section7CanvasContext = null;
    section7CanvasImages = [];//画片帧
    section7CanvasFrames = {frame: 0};//动画帧控制

    /**
     * 头部动画[selection1]
     */
    headerAnimation(){
        this.headerCanvasContext = this.headerCanvasRef.current.getContext("2d");
        this.headerCanvasRef.current.width = 1920;//宽高需要根据实际的图片尺寸来定
        this.headerCanvasRef.current.height = 1080;
        const frameCount = 102;//总帧数(图片数量)
        for (let i = 10; i <= frameCount; i++) {//detail/crane-m3s/M3SAnimation/M3S%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB_00000.jpg
            let imgName = `${i}`.toString().padStart(5,"0") + (i<72 ? '.jpg' : '.png');//生成帧名称
            let curSrc = 'https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/crane-m3s/m3s-opening/m3s-opening-'+imgName;//生成帧链接  https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/crane-m3s/m3s-accessory-cover-large%402x.jpg
            const img = new Image();
            img.src = curSrc;
            this.headerCanvasImages.push(img);
        }
        this.headerCanvasImages[this.headerCanvasFrames.frame].onload = this.headerAnimationCanvasRender.bind(this);
        this.createHeaderAnimationScrollTrigger();
    }

    /**
     * 头部动画帧[selection2]
     */
    headerAnimationCanvasRender(){
        this.headerCanvasContext.clearRect(0, 0,this.headerCanvasRef.current.width, this.headerCanvasRef.current.height);
        this.headerCanvasContext.drawImage(this.headerCanvasImages[this.headerCanvasFrames.frame], 0, 0);//指定图片大小
    }
    /**
     * 创建头部滚动动画[selection2]
     */
    createHeaderAnimationScrollTrigger(){
        let that = this;
        let tl2 = gsap.timeline({//slogan动画-白色闪过
            scrollTrigger: {
                trigger: "."+styles.section1InfoContainer,
                start: "top top",//start、scroller-start
                end:"300% top",
                ease:CustomEase.create("custom", "M0,0 C1,0 1,1 1,1 ")
                // ease:"power2.in"
            }
        }).addLabel("headTextLabel").to( "."+styles.section1InfoContainer, {
            "--detail-m3s-section1-info-bg-offset1":"5.68%",
            "--detail-m3s-section1-info-bg-offset2":"30%",
            "--detail-m3s-section1-info-bg-offset3":"55%",
            duration:1,
            onComplete:function () {//防止透明度被设置为0
                tl4.to(that.headerCanvasFrames, {
                    frame: that.headerCanvasImages.length-1,
                    snap: "frame",
                    onUpdate: that.headerAnimationCanvasRender.bind(that),
                    duration:2
                },"loadProductName")
                    .to("."+styles.section1,{"--detail-m3s-header-canvas-opacity":"0.1"}).addLabel("section1CanvasLabel")
                    .to("."+styles.section2,{y:that.state.screenWidth>1280 ? "-200px" : "-300px","--detail-m3s-section2-opacity":1},"section1CanvasLabel-=0.5");
                if(functions.getWidth()<1280){
                    tl4.to("."+styles.section1Canvas,{height:"63vh"},1.5)
                }

            }
        }).to("."+styles.section1,{"--detail-m3s-header-canvas-opacity":1},"headTextLabel").addLabel("loadProductName").play();

        let tl3 = gsap.timeline({//slogan动画-放大-消失
            scrollTrigger: {
                trigger: "."+styles.section1,
                start: "top top",
                end:"50% top",
                scrub: 1,
            }
        }).to("."+styles.section1InfoContainer,{"transform":"scale(1.2)"})
        .to("."+styles.section1InfoContainer,{"--detail-m3s-section1-info-container-opacity":0,"transform":"translate3d(0px, -200px, 0px) scale(1.2, 1.2)"});


        let tl4 = gsap.timeline({//序列帧动画
            scrollTrigger: {
                // trigger: "."+styles.section1,
                trigger:headerRef.current,
                // pin:  "."+styles.section1,
                pin:true,
                pinSpacing:true,
                start: "top top",//start、scroller-start
                end:"300%",
                scrub: 1,
            }
        });

    }

    /**
     * 打开首页屏视频
     * @param status 状态 1=打开，0=关闭
     */
    videoPlayOrStop(status=0){
        let videoSrc = functions.getLanguage()=='cn' ? 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-tvc-cn.mp4' : 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-tvc-en.mp4'
        if(status===1){//播放
            document.querySelector("."+styles.playerVideoContainer).style.visibility='initial';
            document.querySelector("body").style.overflowY = "hidden";
            document.querySelector("."+styles.playerVideoContainer+">video").src=videoSrc;
            document.querySelector("."+styles.playerVideoContainer+">video").play();
        }else{//关闭
            document.querySelector("."+styles.playerVideoContainer).style.visibility='hidden';
            document.querySelector("body").style.overflowY = "unset";
            document.querySelector("."+styles.playerVideoContainer+">video").src="";
        }
    }

    /**
     * 轻字动画
     */
    section3Animation(){
        let doms = document.querySelectorAll(`.${styles.section3RightBigTitleContainer1Light}`);

        /**
         * 轻字往下掉
         */
        function animationLight() {//动画顺进入
            gsap.to("."+styles.section3RightBigTitleContainer1Light,{duration: 0.8, top: 0,ease:"power1.easeIn"})
        }
        function animationLightBack() {//动画逆进入
            let tl = gsap.timeline();
            let tween = gsap.fromTo("."+styles.section3RightBigTitleContainer1Light, {opacity:1,top:0}, {opacity:1,duration: 0.8, top: "calc(-1 * var(--detail-text-font-size))",ease:"power1.easeIn"});
            tl.add(tween).play();
        }

        /**
         * 非中文版轻字往下掉
         */
        function animationLight2(){
            // let words=doms[0].innerText;
            if(functions.isNull(doms[0])){//重新获取
                doms = document.querySelectorAll(`.${styles.section3RightBigTitleContainer1Light}`);
            }

            let words=doms[0].innerText.split("");
            let outs = '';
            for (let i = 0; i < words.length; i++) {
                outs += `<span style="animation-delay:${i*0.05}s">${words[i]}</span>`;
            }
            doms[0].innerHTML = doms[1].innerHTML = outs;
        }
        gsap.timeline({
            scrollTrigger: {
                // markers:true,
                trigger:this.state.screenWidth>1280 ? "."+styles.section3Right : "."+styles.section3RightBigTitleContainer2,
                start: "top center",//start、scroller-start
                end:"top center",//end、scroller-end
                onEnter:functions.getLanguage()=='cn' ? animationLight : animationLight2,
                // onEnterBack:functions.getLanguage()=='cn' ? animationLightBack : null
            }
        });

    }

    /**
     * 大图手持-视差滚动
     */
    section3LeftImageAnimation(){
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "."+styles.section3Left,
                start: "top center",//start、scroller-start
                end:"bottom top",//end、scroller-end
                scrub: 1,//页面滚动时元素需要 1 秒才能“赶上”滚动条
            }
        });
        //滚动时动画到第N帧停止
        tl.to("."+styles.section3LeftImage, {
            y: 0
        });
    }

    /**
     * 小图机器-视差滚动
     */
    section3RightImageAnimation(){
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "."+styles.section3Right,
                start: "top center",//start、scroller-start
                end:"200% top",//end、scroller-end
                scrub: 1,
            }
        });
        //滚动时动画到第N帧停止
        tl.to("."+styles.section3RightImage, {
            y: this.state.screenWidth>1280 ? -480 : -80
        });
    }

    /**
     * 拆装字动画
     */
    section5Animation(){
        let that = this;
        setTimeout(()=>{
            function animationLight() {//动画顺进入
                gsap.fromTo("."+styles.section5TitleContainerAnimation, {opacity:1}, {opacity:1,duration: 0.5, marginLeft: 0,ease:"power1.easeOut"}).play();
            }
            function animationLightBack() {//动画逆进入
                gsap.fromTo("."+styles.section5TitleContainerAnimation, {opacity:1}, {opacity:1,duration: 0.5, marginLeft: (that.state.screenWidth>767 ? 80 : 40),ease:"power1.easeIn"}).play();
            }
            gsap.timeline({
                scrollTrigger: {
                    // markers:true,
                    trigger: "."+styles.section5TitleContainerAnimation,
                    start: "top center",//start、scroller-start
                    end:"top center",//end、scroller-end
                    scrub: 1,
                    onEnter:animationLight,
                    onEnterBack:animationLightBack
                }
            });
        },1000);
    }

    /**
     * 快拆、创意无限 (固定动画)
     */
    section6Animation(){
        if(this.state.screenWidth>1280){
            let start="top 100%",end="center center";
            let tl = gsap.timeline({
                scrollTrigger: {
                    // markers:true,
                    trigger: "."+styles.section6,
                    pin: "."+styles.section5VideoContainer,
                    start:start,//start、scroller-start
                    end:end,//end、scroller-end
                    scrub: 1,
                }
            });
            //滚动时动画到第N帧停止
            tl.to("."+styles.section6, {
                position:'sticky',zIndex:300000
            });
        }
    }

    /**
     * 搭载动画[selection7]
     */
    section7Animation(){
        this.setState({section7Dom:<CarryEffectAuto
                body={this.state.textData['text61'] ?? ''} note={this.state.textData['text62'] ?? ''}
                align={'center'}
                theme={"light"} href={`/${functions.getLanguage()}/compatibles/index`} eyebrow={this.state.textData['text14'] ?? ''} header={this.state.textData['text15'] ?? ''} model={
                ['Canon EOS M50 Mark II_EF-M 15-45mm f/3.5-6.3 IS STM','SONY α7M3_FE 40mm F2.5G','SONY α6100_E 10–18mm F4 OSS','Nikon Z 50_Z DX 16-50mm f/3.5-6.3 VR']
            } textData={[this.state.textData['text20'] ?? '']} horizontalCombinations={{
                idler:[
                    [{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-idler-with-base-1-large.jpg'}],
                    [{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-idler-with-base-2-large.jpg'}],
                    [{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-idler-with-base-3-large.jpg'}],
                    [{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-idler-with-base-4-large.jpg'}]
                ],
                camera:[
                    {
                        cameraStatic:[{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-with-base2-1-large.png',zIndex:2}],
                        cameraDynamic:[{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-without-base2-1-large.png',zIndex:3},{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-without-base-1-large.png',zIndex:1}]
                    },
                    {
                        cameraStatic:[{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-with-base2-2-large.png',zIndex:2}],
                        cameraDynamic:[{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-without-base2-2-large.png',zIndex:3},{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-without-base-2-large.png',zIndex:1}]
                    },
                    {
                        cameraStatic:[{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-with-base2-3-large.png',zIndex:2}],
                        cameraDynamic:[{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-without-base2-3-large.png',zIndex:3},{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-without-base-3-large.png',zIndex:1}]
                    },
                    {
                        cameraStatic:[{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-with-base2-4-large.png',zIndex:2}],
                        cameraDynamic:[{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-without-base2-4-large.png',zIndex:3},{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-horizontal-camera-without-base-4-large.png',zIndex:1}]
                    },
                ]
            }} cameraNameAnimation="blur" />});
    }

    /**
     * 相册滚动动画 section8
     * 改为循环滚动
     */
    galleryScroll(){
        /*let start = "top 80",end="50% top";
        if(this.state.screenWidth>1280){//PC端
            start = "50% 90%";
            end="50% 0%";
            gsap.utils.toArray(".gallery").forEach((section,index)=>{//相册容器
                const w = section.querySelector("."+styles.section8GalleryContainer);//获取相册
                // const [x, xEnd] = index % 2 ? ["100%", (w.scrollWidth - section.offsetWidth) * -1] : [w.scrollWidth * -1, 0];
                // const [x, xEnd] = index % 2 ? [0, (w.scrollWidth * -1)] : [(w.scrollWidth * -1), 0];//两边会留白
                let this.state.screenWidth = this.state.screenWidth;
                const [x, xEnd] = index % 2 ? [0, (w.scrollWidth * -1 + this.state.screenWidth)] : [(w.scrollWidth * -1 + this.state.screenWidth), 0];//满屏不留白
                gsap.fromTo(w,
                    { x },
                    {
                        x: xEnd,
                        scrollTrigger: {
                            // markers:true,
                            trigger: section,
                            start:start,
                            end:end,
                            scrub: 1 }
                    });
            });
        }else{//移动端,不使用了
            start = "top top";
            end="bottom top";
            const trigger = document.querySelector("."+styles.section8);
            const gallery = document.querySelectorAll("."+styles.section8GalleryContainer);
            gsap.timeline({
                scrollTrigger: {
                    // markers:true,
                    trigger: trigger,
                    start: "top center",
                    end:"top center",
                    onEnter:function () {
                        gallery[0].scrollLeft = gallery[0].scrollWidth;
                        gsap.to(gallery[0], {duration: 1.5, scrollTo:".section8GalleryImage1_1"});
                        gallery[1].scrollLeft = 0;
                        gsap.to(gallery[1], {duration: 1.5, scrollTo:".section8GalleryImage2_4"});
                    },
                    onEnterBack:function (){
                        gsap.to(gallery[0], {duration: 1.5, scrollTo:".section8GalleryImage1_4"});
                        gsap.to(gallery[1], {duration: 1.5, scrollTo:".section8GalleryImage2_1"});
                    }
                }
            },"."+styles.section7)
        }*/

    }

    /**
     * 蓝牙快门动画 section9
     */
    btIconAnimation(){
        let nums = 0;
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '#btIconAnimation',
                start: "center 50%",//start、scroller-start
                end:"center 30%",//end、scroller-end
                //scrub:1,//只播放一次
                onEnter:function () {
                    console.log(`nums=${nums}`)
                    if(nums>0){
                        tl.restart()
                    }else{
                        animation();
                    }
                }
            }
        });
        function animation(){
            tl.to('#btIconAnimation1', {//文字变没
                transform:'scale(0)',
                "transformOrigin":"left bottom",//左下角缩放
                opacity: 0,
            }).addLabel("btStep1")
            .to(['#btIconAnimation2'], {//出现外圈+实心出现
                transform:'scale(1)',
                "transformOrigin":"left bottom",//左下角缩放
                opacity: 1,
                display:'flex',//内圆
                duration:1,
            }).addLabel("btStep2")
            .to(['#btIconAnimation2'], {//外圈变小
                transform:'scale(0.8)',
            }).to(['#BtIconCycle'], {//实心变小+实心变方形
                borderRadius:'8px',
                width:'24px',
                height:'24px',
                duration:1,
            },"btStep2")
            .to(['#btIconAnimation2'], {//外圈变大+实心方形变大
                transform:'scale(1)',
                duration:1
            }).delay(2).to(['#btIconAnimation2'], {//外圈、方形 一起消失
                transform:'scale(0)',
                "transformOrigin":"left bottom",//左下角缩放
                display:'none',
                opacity: 0,
                delay:0.8
            }).to('#btIconAnimation1', {//文字重新出现
                transform:'scale(1)',
                "transformOrigin":"left bottom",//左下角缩放
                opacity: 1,
            });
            nums++;
        }
        function animation_backup(){
            tl.to('#btIconAnimation1', {//文字变没
                transform:'scale(0)',
                // "transformOrigin":"left bottom",//左下角缩放
                opacity: 0,
            }).to('#btIconAnimation2', {//出现外圈
                transform:'scale(1)',
                // "transformOrigin":"left bottom",//左下角缩放
                opacity: 1,
            }).to('#BtIconCycle', {//出现圆圈
                transform:'scale(1)',
                // "transformOrigin":"left bottom",//左下角缩放
                display:'block',
                opacity: 1,
            }).to('#btIconAnimation2', {//外圈变小
                transform:'scale(0.6)'
            }).to('#BtIconCycle', {//圆圈变没
                transform:'scale(0)',
                // "transformOrigin":"left bottom",//左下角缩放
                display:'none',
                opacity: 0,
            }).to('#btIconAnimation2', {//外圈变大
                transform:'scale(1)'
            }).to('#BtIconRect', {//出现方形
                transform:'scale(1)',
                // "transformOrigin":"left bottom",//左下角缩放
                display:'block',
                opacity: 1
            }).to(['#btIconAnimation2','#BtIconRect'], {//外圈、方形 一起消失
                transform:'scale(0)',
                // "transformOrigin":"left bottom",//左下角缩放
                display:'none',
                opacity: 0,
                delay:0.8
            }).to('#btIconAnimation1', {//文字重新出现
                transform:'scale(1)',
                // "transformOrigin":"left bottom",//左下角缩放
                opacity: 1,
            }).duration(2);
            nums++;
        }
    }

    /**
     * 光影右侧，粘性滚动 (背景动画)
     */
    section10BackgroundAnimation(){
        /**
         * 控制背景
         * @type {gsap.core.Timeline}
         */
        gsap.timeline({
            scrollTrigger: {
                // markers:true,
                trigger: "."+styles.section10,
                start: "top 5%",//start、scroller-start
                end:"top 0%",//end、scroller-end
                scrub: 1,
            }
        }).to("."+styles.section10, {
            "--section10-background":"#000000",
            "--section10-header1-color":"#FFFFFF",
            "--section10-header3-color":"#FFFFFF",
            "--section10-animation-background":"#17181A"
        }).addLabel("changeOffset");

        let that = this;
        let nums=0,nums2=0;
        let tl2=gsap.timeline({
            scrollTrigger: {
                // markers:true,
                trigger: "."+styles.section10,
                start: "top 5%",//start、scroller-start
                end:"top 0%",//end、scroller-end
                onEnter:function (){
                    if(nums>0){
                        tl2.restart();
                    }else{
                        animation();
                    }
                },
                onUpdate:function (self) {
                    if(self.progress<0.1){
                        document.querySelector("."+styles.section10Row1LeftHeader2).style="";
                        document.querySelector("."+styles.section10Row1LeftAnimation).style="";
                    }
                }
            }
        });

        /**
         * 控制字体渐变、闪光灯
         */
        function animation(){
            tl2.to("."+styles.section10Row1LeftHeader2,{
                "--section10-header2-color1":"#FF7E33",
                "--section10-header2-color2":"#CCE6FF",
            },"changeOffset")
                .to("."+styles.section10Row1LeftHeader2,{"--section10-header2-offset":"71.4%",duration:0.5}) //字体渐变
                .to("."+styles.section10Row1LeftAnimation,{"--section10-row1-left-image2-opacity":"1",duration:0.5},that.state.screenWidth>768 ? "changeOffset" : "75vh");//闪光灯慢慢变亮
            nums++;
        }

        let tl3=gsap.timeline({
            scrollTrigger: {
                // markers:true,
                trigger: "."+styles.section10Row1Right,
                start: "center 40%",//start、scroller-start
                end:"center 40%",//end、scroller-end
                onEnter:function (){
                    if(nums2>0){
                        tl3.restart();
                    }else{
                        animation2();
                    }
                },
                onUpdate:function (self) {
                    if(self.progress<0.1){
                        document.querySelector("."+styles.section10Row1Right).style="";
                        document.querySelector("."+styles.section10CriBigTitle2).style="";
                        document.querySelector("."+styles.section10CriBigTitle3).style="";
                    }
                }
            }
        });

        /**
         * 控制字体、色温、色值
         */
        function animation2(){
            tl3.to("."+styles.section10Row1Right,{
                "--section10-cri-big-title2-color1":"#FF7E33",
                "--section10-cri-big-title2-color2":"#CCE6FF",
            }).addLabel("section10CriLabel")
                .to("."+styles.section10CriBigTitle2,{"--section10-cri-big-title2-offset":"71.4%",duration:0.5},"section10CriLabel") //字体渐变
                .to("."+styles.section10CriBigTitle3,{
                    "--section10-cri-big-title3-color1":"#FF9999",
                    "--section10-cri-big-title3-color2":"#A799FF",
                    "--section10-cri-big-title3-color3":"#A799FF",
                    "--section10-cri-big-title3-offset2":"66.6%",
                    "--section10-cri-big-title3-offset3":"100%",duration:1
                },"section10CriLabel");//闪光灯慢慢变亮
            nums2++;
        }


        /**
         * 视频播放
         */
        gsap.timeline({
            scrollTrigger: {
                trigger: "."+styles.section10Row1LeftAnimation,
                start: "top center",//start、scroller-start
                end:"top center",//end、scroller-end
                onEnter:function () {
                    videoSection10Ref.current.play();
                },
                onEnterBack:function () {
                    videoSection10Ref.current.play();
                }
            }
        });

    }

    /**
     * 光影右侧，粘性滚动 (固定动画)，暂不使用
     */
    section10Animation(){
        /*if(this.state.screenWidth<1920){//移动端不使用动画
            return false;
        }
        let moveY = -300;
        let tl = gsap.timeline({
            scrollTrigger: {
                // markers:true,
                trigger: "#section10Row1",
                pin: true,
                pinSpacing:true,
                start: "top top",//start、scroller-start
                end:"25% top",//end、scroller-end
                scrub: 1,//页面滚动时元素需要 1 秒才能“赶上”滚动条
            }
        });
        //滚动时动画到第N帧停止
        tl.to("."+styles.section10Row1Right, {
            "y":moveY
        });*/
    }

    /**
     * 移动影像2.0，触发其他生效
     */
    section10MovieV2(){
        setTimeout(()=>{
            this.section7Animation();
            this.galleryScroll();
            this.btIconAnimation();
            this.section10BackgroundAnimation();
        },1000)
        setTimeout(()=>{
            this.setState({section10MovieV2Dom:<Photography20
                    videoProps={{src:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-times.mp4',
                        poster:'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-times-cover.jpg'}}
                    body={this.state.textData['text39'] ?? ''}
                    header={this.state.textData['text38'] ?? ''} />});//插件库

        },2000);
        setTimeout(()=>{
            this.section11ImageAnimation();
            this.sectionColorFulAnimation();
            this.section12Animation();
        },3000);


    }

    /**
     * 按钮切换
     * @param index
     */
    section11ButtonClickHandler(index=0){
        let posIndex = this.state.section11ButtonIndex;
        if(index>posIndex && index<3){
            posIndex = index+1;
        }else if(index<posIndex && index>0){
            posIndex = index-1;
        }else{
            posIndex = index;
        }
        gsap.to("."+styles.section11Scroller, {duration: 1, scrollTo:`#section11Button${posIndex}`});
        this.setState({section11ButtonIndex:posIndex});

        let doms = document.querySelectorAll("."+styles.section11Button);
        let btns = document.querySelectorAll("."+styles.section11ButtonText);//按钮文字
        let medias = document.querySelectorAll(".section11Media");//媒体

        if(index==1){//第二个，延时投影
            videoSection11Ref1.current.play();
            videoSection11Ref2.current.stop();
            videoSection11Ref3.current.stop();
            document.querySelector(`#section11ButtonSplitDot1`).classList.add(styles.section11ButtonSplitDotHide);
            document.querySelector(`#section11ButtonSplitDot2`).classList.add(styles.section11ButtonSplitDotHide);
            document.querySelector(`#section11ButtonSplitDot3`).classList.remove(styles.section11ButtonSplitDotHide);
        }else if(index==2){//第三个，轨迹录像
            videoSection11Ref1.current.stop();
            videoSection11Ref2.current.play();
            videoSection11Ref3.current.stop();
            document.querySelector(`#section11ButtonSplitDot1`).classList.remove(styles.section11ButtonSplitDotHide);
            document.querySelector(`#section11ButtonSplitDot2`).classList.add(styles.section11ButtonSplitDotHide);
            document.querySelector(`#section11ButtonSplitDot3`).classList.add(styles.section11ButtonSplitDotHide);
        }else if(index==3){//第四个，三维梦境
            videoSection11Ref1.current.stop();
            videoSection11Ref2.current.stop();
            videoSection11Ref3.current.play();
            document.querySelector(`#section11ButtonSplitDot1`).classList.remove(styles.section11ButtonSplitDotHide);
            document.querySelector(`#section11ButtonSplitDot2`).classList.remove(styles.section11ButtonSplitDotHide);
            document.querySelector(`#section11ButtonSplitDot3`).classList.add(styles.section11ButtonSplitDotHide);
        }else{//第一个，全景影像
            videoSection11Ref1.current.stop();
            videoSection11Ref2.current.stop();
            videoSection11Ref3.current.stop();
            //由于没有资源暂时隐藏功能
            // document.querySelector(`#section11ButtonSplitDot1`).classList.add(styles.section11ButtonSplitDotHide);
            // document.querySelector(`#section11ButtonSplitDot2`).classList.remove(styles.section11ButtonSplitDotHide);
            // document.querySelector(`#section11ButtonSplitDot3`).classList.remove(styles.section11ButtonSplitDotHide);
        }
        for(let i=0;i<doms.length;i++){
            let svgDom = doms[i].querySelectorAll("svg");
            if(i==index){//选中
                doms[i].classList.remove(styles.section11ButtonBackgroundHide);
                btns[i].classList.add(styles.section11ButtonTextBlack);
                medias[i].classList.remove(styles.section11MediaHide);
                setSvg(svgDom,false);
            }else{
                doms[i].classList.add(styles.section11ButtonBackgroundHide);
                btns[i].classList.remove(styles.section11ButtonTextBlack);
                medias[i].classList.add(styles.section11MediaHide);
                setSvg(svgDom);
            }
        }
        function setSvg(dom,hide=true) {
            for(let j=0;j<dom.length;j++){
                if(hide){
                    dom[j].classList.add(styles.section11ButtonSvgHide);
                }else{
                    dom[j].classList.remove(styles.section11ButtonSvgHide);
                }
            }
        }
    }

    /**
     * 彩屏显示动画
     */
    sectionColorFulAnimation(){
        let tl = gsap.timeline({
            scrollTrigger: {
                // markers:true,
                trigger: "."+styles.sectionColorScreen,
                // pin: true,
                // pinSpacing:true,
                start: "top 75%",//start、scroller-start
                end:"top center",//end、scroller-end
                scrub: 1,//页面滚动时元素需要 1 秒才能“赶上”滚动条
            }
        });
        //滚动时动画到第N帧停止
        tl.to("."+styles.sectionColorScreenRow1, {
            "--detail-m3-color-screen-color1":"#12C2E9",
            "--detail-m3-color-screen-color2":"#C471ED",
            "--detail-m3-color-screen-color3":"#F64F59",
        }).to("."+styles.textStrongColorFul,{
            "--detail-m3-color-screen-color1-offset":"0%",
            "--detail-m3-color-screen-color2-offset":"75%",
            "--detail-m3-color-screen-color3-offset":"100%"
        });
    }

    /**
     * 创意纤巧精致-全景图片-动画
     */
    section11ImageAnimation(){
        // if(this.state.screenWidth<=1280){//移动端不使用动画
        //     return false;
        // }
        let height = document.querySelector('.'+styles.section1).clientHeight;
        let width=this.state.screenWidth;
        let start = "top 15%";
        let end = "center top";

        let sObject = "."+styles.section11MediaContainer;
        let fromVars = {};
        let toVars = {};

        if(width>1920){
            width = ((2560-1600))/2;
            start = `top ${(height-900)/2}`;

            fromVars = {"--detail-m3s-section11-image-cover-width":`${width}px`};
            toVars = {"--detail-m3s-section11-image-cover-width":"0"};
        }else if(width>1280){
            width = ((1920-1200))/2;
            start = `top ${(height-900)/2}`;
            fromVars = {"--detail-m3s-section11-image-cover-width":`${width}px`};
            toVars = {"--detail-m3s-section11-image-cover-width":"0"};
        }else{
            // start = `center ${(height-520)/2}`;
            start = `top 25%`;
            end = "bottom 25%";
            sObject = "." + styles.section11MediaImage
            fromVars = {"left":`0px`};
            toVars = {"left":`${this.state.screenWidth-1600}px`,duration:2};//2560-1600
        }

        let tl = gsap.timeline({
            scrollTrigger: {
                // markers:true,
                // trigger: "."+styles.section11MediaImageContainer,
                trigger:"."+styles.section11,
                // pin:'.'+styles.section11,
                // pinSpacing:true,
                start: "top 25%",//start、scroller-start
                end:"center 25%",//end、scroller-end
                scrub: 1,
            }
        });



        tl.from(sObject,fromVars).to(sObject, toVars);
    }

    /**
     * 续航动画
     */
    section12Animation(){
        let tl = gsap.timeline({//模块容器背景
            scrollTrigger: {
                // markers:true,
                trigger: "."+styles.section12,
                start: "top center",//start、scroller-start
                end:"top center",//end、scroller-end
                scrub: 1,
        }}).to("."+styles.section12, {
                background:"#000000",
                "--section12-text-color":"#FFFFFF",
            });

        if(this.state.screenWidth>1280){
            /*gsap.timeline({
                scrollTrigger: {
                    // markers:true,
                    trigger: "."+styles.section12,
                    pin:true,
                    pinSpacing:true,
                    start: "top top",
                    end:"center top",
                    scrub: 1,
                }})
                // .to(["#section12LeftTextContainer1","#section12LeftTextContainer2"],{transform:`translateY(-${document.querySelector("#section12LeftTextContainer1").clientHeight*0.8}px)`,duration:1});
                .to(["#section12LeftTextContainer1","#section12LeftTextContainer2"],{top:`-${document.querySelector("#section12LeftTextContainer1").clientHeight}px`,duration:1});
            */
            gsap.timeline({
                scrollTrigger: {
                    // markers:true,
                    trigger: "#section12LeftTextContainer2",
                    start: "center center",//start、scroller-start
                    end:"center center",//end、scroller-end
                    scrub: 1,
                }}).to("."+styles.section12LeftTextP2,{"--section12-text-cover-width":"100%",duration:1});
        }else{
            gsap.timeline({
                scrollTrigger: {
                    // markers:true,
                    trigger: "#section12LeftTextContainer2",
                    start: "top center",//start、scroller-start
                    end:"top center",//end、scroller-end
                    scrub: 1,
                }}).to(["#section12LeftTextContainer2"],{
                "--section12-text-cover-width":"100%",duration:1
            });
        }

    }

    render() {
        return (functions.isNull(this.state.textData) ? null : <>
            <div className={styles.pageContainer} onClick={()=>{
            //if(functions.isWeixin() && this.state.isWeiXinPlay){
                videoSection5Ref.current.play();
                videoSection6Ref.current.play();
                if(functions.getLanguage()=='cn'){
                    videoSection9Ref.current.play();
                }
                // videoColorScreenRef.current.play();
                this.setState({isWeiXinPlay:false});//防止多次播放
            //}
        }}>
            <section className={styles.section1} ref={headerRef}>
                <div className={styles.section1AnimationContainer}>
                    <canvas ref={this.headerCanvasRef} className={styles.section1Canvas}></canvas>
                </div>
                <div className={styles.section1InfoContainer}>
                    <Text figmaStyle={'slogan'} label={'h2'} className={styles.slogan}>{this.state.textData['text1'] ?? ''}</Text>
                    <Text figmaStyle={'productName'} label={'h1'} className={styles.productName}>{this.state.textData['text2'] ?? 'CRANE-M 3S'}</Text>
                </div>

                <section className={styles.section2}>
                    <Text figmaStyle={'introduction'} label={'h2'} className={styles.introduction}>
                        {this.state.textData['text3'] ?? ''}
                    </Text>
                    <div className={styles.videoBtnContainer}>
                        <Play theme={"fill"} />
                        <div className={styles.videoBtnText} onClick={this.videoPlayOrStop.bind(this,1)}>{this.state.textData['text4'] ?? ''}</div>
                    </div>
                </section>
            </section>

            <div className={styles.playerVideoContainer}>
                <video autoPlay={false} loop playsInline preload="true" controls src={functions.getLanguage()=='cn' ? 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-tvc-cn.mp4' : 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-tvc-cn.mp4'}></video>
                <div className={styles.playerVideoClose} onClick={this.videoPlayOrStop.bind(this,0)}>
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="13" cy="13" r="12" stroke="#FFF" strokeWidth="2"></circle>
                        <line x1="8.7574" y1="8.75725" x2="17.2427" y2="17.2425" stroke="#FFF" strokeWidth="2"></line>
                        <line x1="17.2428" y1="8.7574" x2="8.75747" y2="17.2427" stroke="#FFF" strokeWidth="2"></line>
                    </svg>
                </div>
                <div className={styles.playerVideoCover} onClick={this.videoPlayOrStop.bind(this,0)}></div>
            </div>

            {/*设计、以轻助力*/}
            <section className={styles.section3}>
                <div className={styles.section3RightBigTitleContainer2}>
                    <Text figmaStyle={"eyebrow"} label={'h2'}  className={`${styles.section3RightBigTitleContainer1Design} ${functions.getLanguage()=='cn' ? '' : styles.en}`}>{this.state.textData['text5'] ?? ''}</Text>
                    <Text figmaStyle={"header-1"} label={'h3'} formatParam={{strongClassName:styles.section3RightBigTitleContainer1Light}}>
                        {/*`以{轻}助力`*/}
                        {this.state.textData['text6'] ?? ''}
                    </Text>
                    <Text figmaStyle={"header-1"} label={'h3'}>
                        {/*以优护航*/}
                        {this.state.textData['text7'] ?? ''}
                    </Text>
                </div>
                <div className={styles.section3Left}>
                    <div className={styles.section3LeftImageContainer}>
                        <ZyImage className={styles.section3LeftImage}
                                 src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-1-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-1-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-1-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-1-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-1-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-1-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-1-large@2x.jpg",
                                         ],
                                     },
                                 ]}/>
                    </div>
                </div>
                <div className={styles.section3Right}>
                    <div className={styles.section3RightBigTitleContainer1}>
                        <Text figmaStyle={"eyebrow"} label={'h2'} className={`${styles.section3RightBigTitleContainer1Design} ${functions.getLanguage()=='cn' ? '' : styles.en}`}>
                            {/*设计*/}
                            {this.state.textData['text5'] ?? ''}
                        </Text>
                        <Text figmaStyle={"header-1"} label={'h3'} formatParam={{strongClassName:styles.section3RightBigTitleContainer1Light}}>
                            {/*{`以{轻}助力`}*/}
                            {this.state.textData['text6'] ?? ''}
                        </Text>
                        <Text figmaStyle={"header-1"} label={'h3'}>
                            {/*以优护航*/}
                            {this.state.textData['text7'] ?? ''}
                        </Text>
                    </div>
                    <div className={styles.section3RightImageContainer}>
                        <div className={styles.section3RightImageCover}></div>
                            <ZyImage className={styles.section3RightImage}
                                   src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-2-large.jpg'
                                   sources={[
                                       {
                                           srcsets: [
                                               "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-2-medium.jpg",
                                               "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-2-medium@2x.jpg",
                                           ],
                                           media: "(max-width:1024px)",
                                       },
                                       {
                                           srcsets: [
                                               "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-2-small.jpg",
                                               "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-2-small@2x.jpg",
                                           ],
                                           media: "(max-width:768px)",
                                       },
                                       {
                                           srcsets: [
                                               "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-2-large.jpg",
                                               "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-2-large@2x.jpg",
                                           ],
                                       },
                                   ]}/>
                    </div>

                    <Text figmaStyle={"body"} label={"p"} className={styles.section3InstructionContainer} formatParam={{strongClassName:styles.textStrongBlack}}>
                        {/*{`云鹤M3 S轻巧而不失内涵，{705克机身可轻松搭载主流相机镜头}，实现轻量化与高负载的完美平衡，尽享摄影魅力，造就视觉艺术极致美学。`}*/}
                        {this.state.textData['text8'] ?? ''}
                    </Text>
                    <Text figmaStyle={"note"} label={'p'} className={styles.section3Instruction}>
                        {/** 相关功能和详细相机适配情况请查阅官网。*/}
                        {this.state.textData['text9'] ?? ''}
                    </Text>

                </div>
            </section>

            {/*大图*/}
            <section className={styles.section4}>
                <ZyImage className={styles.section4Image} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-3-large.jpg'
                         sources={[
                             {
                                 srcsets: [
                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-3-medium.jpg",
                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-3-medium@2x.jpg",
                                 ],
                                 media: "(max-width:1024px)",
                             },
                             {
                                 srcsets: [
                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-3-small.jpg",
                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-3-small@2x.jpg",
                                 ],
                                 media: "(max-width:768px)",
                             },
                             {
                                 srcsets: [
                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-3-large.jpg",
                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-appearance-3-large@2x.jpg",
                                 ],
                             },
                         ]}/>
            </section>

            {/*快拆、创意无限文字*/}
            <section className={styles.section5TextContainer}>
                <Text figmaStyle={"eyebrow"} label={'h2'}>
                    {/*快拆*/}
                    {this.state.textData['text10'] ?? ''}
                </Text>
                <Text figmaStyle={"header-1"} label={'h3'}>
                    {/*创意无限*/}
                    {this.state.textData['text11'] ?? ''}
                </Text>
                <Text figmaStyle={"header-1"} label={'h3'} formatParam={{strongClassName:styles.section5TitleContainerAnimation}}>
                    {/*{`自如{拆装}`}*/}
                    {this.state.textData['text12'] ?? ''}
                </Text>
                <div className={styles.section5InstructionContainer}>
                    <div></div>
                    <Text figmaStyle={"body"} label={'p'} className={styles.section5Instruction} formatParam={{strongClassName:styles.textStrongBlack}}>
                        {/*{`全新定制快拆系统，{使用时无需反复调平}；独特双层设计，兼容众多主流相机，{更换电池无需拆卸相机}，畅享非凡摄影时光。`}*/}
                        {this.state.textData['text13'] ?? ''}
                    </Text>
                </div>
            </section>

            {/*创意无限、快拆视频1*/}
            <section className={styles.section5}>
                <div className={styles.section5VideoContainer}>
                    <Video
                        ref={videoSection5Ref}
                        className={styles.section5Video}
                        src={
                            'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-quick-release-battery.mp4'
                        }
                        source={[
                            {
                                src: 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-quick-release-battery.mp4',
                                type: 'video/mp4',
                            },
                        ]}
                        poster={
                            'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-quick-release-battery-cover-large.jpg'
                        }
                    />
                </div>
            </section>

            {/*自由拆装、快拆视频2*/}
            <section className={styles.section6}>

                    <Video
                        ref={videoSection6Ref}
                        className={styles.section6Video}
                        src={
                            'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-quick-release.mp4'
                        }
                        source={[
                            {
                                src: 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-quick-release.mp4',
                                type: 'video/mp4',
                            },
                        ]}
                        poster={
                            'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-quick-release-cover.jpg'
                        }
                    />

            </section>

            {/*承载微单*/}
            <section className={styles.section7}>
                {this.state.section7Dom}
            </section>

            {/*滚动相册1*/}
            <section className={`${styles.section8} ${styles.section8First} gallery`}>
                <div>
                    <div className={styles.section8GalleryContainer}>
                        <ZyImage className={`${styles.section8GalleryImage} section8GalleryImage1_1`} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-large.jpg'
                               sources={[
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-medium.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-medium@2x.jpg",
                                       ],
                                       media: "(max-width:1024px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-small.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-small@2x.jpg",
                                       ],
                                       media: "(max-width:768px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-large.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-large@2x.jpg",
                                       ],
                                   },
                               ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-large.jpg'
                               sources={[
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-medium.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-medium@2x.jpg",
                                       ],
                                       media: "(max-width:1024px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-small.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-small@2x.jpg",
                                       ],
                                       media: "(max-width:768px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-large.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-large@2x.jpg",
                                       ],
                                   },
                               ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-large.jpg'
                               sources={[
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-medium.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-medium@2x.jpg",
                                       ],
                                       media: "(max-width:1024px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-small.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-small@2x.jpg",
                                       ],
                                       media: "(max-width:768px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-large.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-large@2x.jpg",
                                       ],
                                   },
                               ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-large.jpg'
                               sources={[
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-medium.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-medium@2x.jpg",
                                       ],
                                       media: "(max-width:1024px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-small.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-small@2x.jpg",
                                       ],
                                       media: "(max-width:768px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-large.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-large@2x.jpg",
                                       ],
                                   },
                               ]} />
                        <ZyImage className={`${styles.section8GalleryImage} section8GalleryImage1_4`} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-large.jpg'
                               sources={[
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-medium.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-medium@2x.jpg",
                                       ],
                                       media: "(max-width:1024px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-small.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-small@2x.jpg",
                                       ],
                                       media: "(max-width:768px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-large.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-large@2x.jpg",
                                       ],
                                   },
                               ]} />
                    </div>
                    <div className={styles.section8GalleryContainer}>
                        <ZyImage className={`${styles.section8GalleryImage} section8GalleryImage1_1`} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-01-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-02-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-03-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-04-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={`${styles.section8GalleryImage} section8GalleryImage1_4`} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-05-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                    </div>
                </div>
            </section>

            {/*滚动相册2*/}
            <section className={`${styles.section8} ${styles.section8Last} gallery`}>
                <div>
                    <div className={styles.section8GalleryContainer}>
                        <ZyImage className={`${styles.section8GalleryImage} section8GalleryImage2_1`} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={`${styles.section8GalleryImage} section8GalleryImage2_4`} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                    </div>
                    <div className={styles.section8GalleryContainer}>
                        <ZyImage className={`${styles.section8GalleryImage} section8GalleryImage2_1`} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-06-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-07-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-08-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={styles.section8GalleryImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-09-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                        <ZyImage className={`${styles.section8GalleryImage} section8GalleryImage2_4`} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-large.jpg'
                                 sources={[
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-medium.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-medium@2x.jpg",
                                         ],
                                         media: "(max-width:1024px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-small.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-small@2x.jpg",
                                         ],
                                         media: "(max-width:768px)",
                                     },
                                     {
                                         srcsets: [
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-large.jpg",
                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-equipped-10-large@2x.jpg",
                                         ],
                                     },
                                 ]} />
                    </div>
                </div>
            </section>

            {/*记录、蓝牙快门*/}
            <section className={styles.section9}>

                <div className={styles.section9Row1Left}>
                    <div id='btIconAnimation' style={{width:60,height:60,display:"flex",justifyContent:"center",alignItems:"center"}}>
                        <div className={styles.BtIconText} id='btIconAnimation1'>
                            <Text figmaStyle={"eyebrow"} label={'h2'}>
                                {/*记录*/}
                                {this.state.textData['text21'] ?? ''}
                            </Text>
                        </div>
                        <div className={styles.BtIconContainer} id='btIconAnimation2'>
                            <div className={styles.BtIconCycle} id='BtIconCycle'></div>
                            {/*<div className={styles.BtIconRect} id='BtIconRect'></div>*/}
                        </div>
                    </div>

                    <Text figmaStyle={"header-1"} label={'h3'}>
                        {/*无线自在*/}
                        {this.state.textData['text22'] ?? ''}
                    </Text>
                    <Text figmaStyle={"header-1"} label={'h3'}>
                        {/*轻盈随我*/}
                        {this.state.textData['text23'] ?? ''}
                    </Text>
                </div>



                <div className={styles.section9Row1Right}>
                    <div>
                        <Text figmaStyle={"body"} label={'p'} className={styles.section9Instruction} formatParam={{strongClassName:styles.textStrongBlack}}>
                            {/*{`{新增蓝牙快门控制功能}，轻触机身按键，云鹤M3 S即可实现流畅{无线调焦、录制}等操作，拍摄体验提升至精致简洁新高度，告别繁琐接线烦恼，美好瞬间触手可得，尽享摄影韵味。`}*/}
                            {this.state.textData['text24'] ?? ''}
                        </Text>
                        <Text figmaStyle={"note"} label={'p'} className={styles.section5Fix}>
                            {/**详细适配功能参阅适配列表。*/}
                            {this.state.textData['text63'] ?? ''}
                        </Text>
                    </div>
                </div>


                <div className={styles.section9Row2}>
                    {
                        functions.getLanguage()=='cn' ? <Video
                            ref={videoSection9Ref}
                            className={styles.section9Video}
                            videoStyle={{ objectFit: 'cover' }}
                            src={
                                'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter.mp4'
                            }
                            source={[
                                {
                                    src: 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter.mp4',
                                    type: 'video/mp4',
                                },
                            ]}
                            poster={
                                'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter-cover.jpg'
                            }
                        /> : <ZyImage
                            className={`${styles.section9Video}`}
                            src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter-en-large.jpg'
                            sources={[
                                {
                                    srcsets: [
                                        "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter-en-medium.jpg",
                                        "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter-en-medium@2x.jpg",
                                    ],
                                    media: "(max-width:1024px)",
                                },
                                {
                                    srcsets: [
                                        "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter-en-small.jpg",
                                        "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter-en-small@2x.jpg",
                                    ],
                                    media: "(max-width:768px)",
                                },
                                {
                                    srcsets: [
                                        "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter-en-large.jpg",
                                        "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-bluetooth-shutter-en-large@2x.jpg",
                                    ],
                                },
                            ]} />
                    }

                </div>
            </section>

            {/*光影、内嵌补光*/}
            <section className={styles.section10}>
                <div className={styles.section10Row1} id={'section10Row1'}>
                    <div className={styles.section10Row1Left}>
                        <div className={styles.section10Row1LeftHeaderContainer}>
                            <Text figmaStyle={"eyebrow"} label={'h2'}>
                                {/*光影*/}
                                {this.state.textData['text25'] ?? ''}
                            </Text>
                            {/*<Text figmaStyle={"header-1"} label={'h3'} className={styles.section10Row1LeftHeader1}>内嵌补光</Text>*/}
                            <Text figmaStyle={"header-1"} label={'h3'} className={styles.section10Row1LeftHeader2}>
                                {/*内嵌补光*/}
                                {this.state.textData['text26'] ?? ''}
                            </Text>
                            <Text figmaStyle={"header-1"} label={'h3'} className={styles.section10Row1LeftHeader3}>
                                {/*光影随行*/}
                                {this.state.textData['text27'] ?? ''}
                            </Text>
                        </div>
                        {/*section10Row1RightImage大图片相同*/}
                        <div className={styles.section10Row1RightImage2Container}>
                            <ZyImage className={styles.section10Row1RightImage2} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-large.jpg'
                                     sources={[
                                         {
                                             srcsets: [
                                                 "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-medium.jpg",
                                                 "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-medium@2x.jpg",
                                             ],
                                             media: "(max-width:1024px)",
                                         },
                                         {
                                             srcsets: [
                                                 "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-small.jpg",
                                                 "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-small@2x.jpg",
                                             ],
                                             media: "(max-width:768px)",
                                         },
                                         {
                                             srcsets: [
                                                 "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-large.jpg",
                                                 "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-large@2x.jpg",
                                             ],
                                         },
                                     ]}/>
                        </div>
                        <div className={styles.section10Row1LeftAnimation}>
                            {/*<ZyImage className={styles.section10Row1LeftAnimationImage} src={"https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-2-large.png"}*/}
                            {/*         sources={[*/}
                            {/*             {*/}
                            {/*                 srcsets: [*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-2-medium.png",*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-2-medium@2x.png",*/}
                            {/*                 ],*/}
                            {/*                 media: "(max-width:1024px)",*/}
                            {/*             },*/}
                            {/*             {*/}
                            {/*                 srcsets: [*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-2-small.png",*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-2-small@2x.png",*/}
                            {/*                 ],*/}
                            {/*                 media: "(max-width:768px)",*/}
                            {/*             },*/}
                            {/*             {*/}
                            {/*                 srcsets: [*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-2-large.png",*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-2-large@2x.png",*/}
                            {/*                 ],*/}
                            {/*             },*/}
                            {/*         ]}/>*/}
                            {/*<ZyImage className={styles.section10Row1LeftAnimationImage2} src={"https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-3-large.png"}*/}
                            {/*         sources={[*/}
                            {/*             {*/}
                            {/*                 srcsets: [*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-3-medium.png",*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-3-medium@2x.png",*/}
                            {/*                 ],*/}
                            {/*                 media: "(max-width:1024px)",*/}
                            {/*             },*/}
                            {/*             {*/}
                            {/*                 srcsets: [*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-3-small.png",*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-3-small@2x.png",*/}
                            {/*                 ],*/}
                            {/*                 media: "(max-width:768px)",*/}
                            {/*             },*/}
                            {/*             {*/}
                            {/*                 srcsets: [*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-3-large.png",*/}
                            {/*                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-3-large@2x.png",*/}
                            {/*                 ],*/}
                            {/*             },*/}
                            {/*         ]}/>*/}
                            <Video
                                options={{autoplay:false,loop:false}}
                                ref={videoSection10Ref}
                                className={`${styles.section10Row1LeftAnimationImage}`}
                                videoStyle={{ objectFit: 'cover' }}
                                src={
                                    'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light.mp4'
                                }
                                source={[
                                    {
                                        src: 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light.mp4',
                                        type: 'video/mp4',
                                    },
                                ]}
                                poster={
                                    'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-cover.jpg'
                                }
                            />
                        </div>
                        <Text figmaStyle={"body"} label={'p'} className={styles.section10Instruction} formatParam={{strongClassName:styles.textStrongWhite}}>
                            {/*{`{智云自研Lumen Amplifier亮度增倍技术}，指甲盖大小光源释放高达1000Lux亮度，璀璨光影尽收眼底。`}*/}
                            {this.state.textData['text28'] ?? ''}
                        </Text>
                    </div>

                    <div className={styles.section10Row1Right} id={'section10Row1Right'}>
                        {/*section10Row1RightImage大图片相同*/}
                        <ZyImage className={styles.section10Row1RightImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-large.jpg'
                               sources={[
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-medium.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-medium@2x.jpg",
                                       ],
                                       media: "(max-width:1024px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-small.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-small@2x.jpg",
                                       ],
                                       media: "(max-width:768px)",
                                   },
                                   {
                                       srcsets: [
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-large.jpg",
                                           "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-light-1-large@2x.jpg",
                                       ],
                                   },
                               ]}/>
                        <Text figmaStyle={"cir-small-title"} className={styles.section10CriSmallTitle}>
                            {/*最大照度*/}
                            {this.state.textData['text29'] ?? ''}
                        </Text>
                        <Text figmaStyle={"cir-big-title"} className={styles.section10CriBigTitle1}>
                            {/*1000*/}
                            {this.state.textData['text30'] ?? ''}
                            <div className={styles.section10CriUint}>
                                {/*Lux*/}
                                {this.state.textData['text31'] ?? ''}
                            </div>
                        </Text>

                        <Text figmaStyle={"cir-small-title"} className={styles.section10CriSmallTitle}>
                            {/*色温*/}
                            {this.state.textData['text32'] ?? ''}
                        </Text>
                        <Text figmaStyle={"cir-big-title"} className={styles.section10CriBigTitle2}>
                            {/*2700-5500*/}
                            {this.state.textData['text33'] ?? ''}
                            <div className={styles.section10CriUint}>
                                {/*k*/}
                                {this.state.textData['text34'] ?? ''}
                            </div>
                        </Text>

                        <Text figmaStyle={"cir-small-title"} className={styles.section10CriSmallTitle}>
                            {/*显色指数*/}
                            {this.state.textData['text35'] ?? ''}
                        </Text>
                        <Text figmaStyle={"cir-big-title"} className={styles.section10CriBigTitle3}>
                            {/*90*/}
                            {this.state.textData['text36'] ?? ''}
                            <div className={styles.section10CriUint}>
                                {/*+*/}
                                {this.state.textData['text37'] ?? ''}
                            </div>
                        </Text>
                    </div>

                </div>
            </section>

            {/*移动影像2.0*/}
            <div style={{"--detail-text-color":"white !important"}}>
                {this.state.section10MovieV2Dom}
            </div>

            {/*创意、纤巧精致*/}
             <section className={styles.section11}>
                 <div className={styles.section11Row1}>
                     <div>
                         <Text figmaStyle={"eyebrow"} label={'h2'}>
                             {/*创意*/}
                             {this.state.textData['text40'] ?? ''}
                         </Text>
                         <Text figmaStyle={"header-1"} label={'h3'}>
                             {/*纤巧精致_功能不减*/}
                             {this.state.textData['text41'] ?? ''}
                         </Text>
                     </div>
                     <div></div>
                 </div>
                 <div className={styles.section11Row2}>
                     <div></div>
                     <div>
                         <Text figmaStyle={"body"} label={'p'} className={`${styles.section11Instruction}`} formatParam={{strongClassName:styles.textStrongBlack,strongCharacter:{left:'{',right:'}'}}}>
                             {/*{`精巧设计下蕴含无穷潜能；{云鹤M3 S适配多种云台模式，并内置多种拍摄功能}，激发摄影创意，造就独特光影视界。`}*/}
                             {this.state.textData['text42'] ?? ''}
                         </Text>
                     </div>
                 </div>

                 <div className={styles.section11MediaContainer}>

                     {/*全景相片*/}
                     <div className={`section11Media ${styles.section11MediaImageContainer}`}>
                         <ZyImage className={styles.section11MediaImage} src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-cover-large.jpg'
                                sources={[
                                    {
                                        srcsets: [
                                            "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-cover-medium.jpg",
                                            "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-cover-medium@2x.jpg",
                                        ],
                                        media: "(max-width:1024px)",
                                    },
                                    {
                                        srcsets: [
                                            "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-cover-small.jpg",
                                            "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-cover-small@2x.jpg",
                                        ],
                                        media: "(max-width:768px)",
                                    },
                                    {
                                        srcsets: [
                                            "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-cover-large.jpg",
                                            "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-cover-large@2x.jpg",
                                        ],
                                    },
                                ]}/>
                     </div>

                     <div className={styles.section11MediaImageCover}>
                         <div></div>
                         <div></div>
                     </div>

                     {/*延时摄影*/}
                     <Video
                         autoplay={false}
                         ref={videoSection11Ref1}
                         className={`section11Media ${styles.section11Video} ${styles.section11MediaHide}`}
                         videoStyle={{ objectFit: 'cover' }}
                         src={
                             'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-dreams.mp4'
                         }
                         source={[
                             {
                                 src: 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-dreams.mp4',
                                 type: 'video/mp4',
                             },
                         ]}
                         poster={
                             'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-dreams-cover.jpg'
                         }
                     />

                     {/*轨迹影像*/}
                     <Video
                         autoplay={false}
                         ref={videoSection11Ref2}
                         className={`section11Media ${styles.section11Video2} ${styles.section11MediaHide}`}
                         videoStyle={{ objectFit: 'cover' }}
                         src={
                             'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-dreams.mp4'
                         }
                         source={[
                             {
                                 src: 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-dreams.mp4',
                                 type: 'video/mp4',
                             },
                         ]}
                         poster={
                             'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-dreams-cover.jpg'
                         }
                     />

                     {/*三维梦境*/}
                     <Video
                         autoplay={false}
                         ref={videoSection11Ref3}
                         className={`section11Media ${styles.section11Video2} ${styles.section11MediaHide}`}
                         videoStyle={{ objectFit: 'cover' }}
                         src={
                             'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-dreams.mp4'
                         }
                         source={[
                             {
                                 src: 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-dreams.mp4',
                                 type: 'video/mp4',
                             },
                         ]}
                         poster={
                             'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-dreams-cover.jpg'
                         }
                     />

                 </div>

                 <div className={styles.section11Scroller}>
                     <div className={styles.section11ButtonsContainer}>
                         <div className={styles.section11Button} onClick={this.section11ButtonClickHandler.bind(this,0)} id={"section11Button0"}>
                             <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M0 0H12V1H1V12H0V0Z" fill="black"/>
                             </svg>
                             <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M12 3.4969e-07V12H11V1L0 1L5.96046e-08 0L12 3.4969e-07Z" fill="black"/>
                             </svg>
                             <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M12 12H0L5.96046e-08 11H11V0L12 5.96046e-08L12 12Z" fill="black"/>
                             </svg>
                             <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M3.49691e-07 12L0 5.96046e-08L1 0L1 11H12V12H3.49691e-07Z" fill="black"/>
                             </svg>

                             <Text figmaStyle={"header-3"} label={'h3'} className={`${styles.section11ButtonText} ${styles.section11ButtonTextBlack}`}>
                                 {/*全景拍摄*/}
                                 {this.state.textData['text43'] ?? ''}
                             </Text>
                         </div>

                         <div className={`${styles.section11ButtonSplitDot}`} id={'section11ButtonSplitDot1'}></div>
                         <div className={`${styles.section11Button} ${styles.section11ButtonBackgroundHide} ${styles.section11ButtonHidden}`} onClick={this.section11ButtonClickHandler.bind(this,1)} id={"section11Button1"}>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M0 0H12V1H1V12H0V0Z" fill="black"/>
                             </svg>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M12 3.4969e-07V12H11V1L0 1L5.96046e-08 0L12 3.4969e-07Z" fill="black"/>
                             </svg>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M12 12H0L5.96046e-08 11H11V0L12 5.96046e-08L12 12Z" fill="black"/>
                             </svg>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M3.49691e-07 12L0 5.96046e-08L1 0L1 11H12V12H3.49691e-07Z" fill="black"/>
                             </svg>
                             <Text figmaStyle={"header-3"} label={'h3'} className={styles.section11ButtonText}>
                                 {/*延时摄影*/}
                                 {this.state.textData['text44'] ?? ''}
                             </Text>
                         </div>

                         <div className={`${styles.section11ButtonSplitDot}  ${styles.section11ButtonHidden}`} id={'section11ButtonSplitDot2'}></div>
                         <div  className={`${styles.section11Button} ${styles.section11ButtonBackgroundHide} ${styles.section11ButtonHidden}`} onClick={this.section11ButtonClickHandler.bind(this,2)} id={"section11Button2"}>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M0 0H12V1H1V12H0V0Z" fill="black"/>
                             </svg>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M12 3.4969e-07V12H11V1L0 1L5.96046e-08 0L12 3.4969e-07Z" fill="black"/>
                             </svg>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M12 12H0L5.96046e-08 11H11V0L12 5.96046e-08L12 12Z" fill="black"/>
                             </svg>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M3.49691e-07 12L0 5.96046e-08L1 0L1 11H12V12H3.49691e-07Z" fill="black"/>
                             </svg>
                             <Text figmaStyle={"header-3"} label={'h3'} className={styles.section11ButtonText}>
                                 {/*轨迹录像*/}
                                 {this.state.textData['text45'] ?? ''}
                             </Text>
                         </div>

                         <div className={`${styles.section11ButtonSplitDot} ${styles.section11ButtonHidden}`} id={'section11ButtonSplitDot3'}></div>
                         <div  className={`${styles.section11Button} ${styles.section11ButtonBackgroundHide}`} onClick={this.section11ButtonClickHandler.bind(this,3)} id={"section11Button3"}>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M0 0H12V1H1V12H0V0Z" fill="black"/>
                             </svg>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M12 3.4969e-07V12H11V1L0 1L5.96046e-08 0L12 3.4969e-07Z" fill="black"/>
                             </svg>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M12 12H0L5.96046e-08 11H11V0L12 5.96046e-08L12 12Z" fill="black"/>
                             </svg>
                             <svg className={styles.section11ButtonSvgHide} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fillRule="evenodd" clipRule="evenodd" d="M3.49691e-07 12L0 5.96046e-08L1 0L1 11H12V12H3.49691e-07Z" fill="black"/>
                             </svg>
                             <Text figmaStyle={"header-3"} label={'h3'} className={styles.section11ButtonText}>
                                 {/*盗梦空间*/}
                                 {this.state.textData['text46'] ?? ''}
                             </Text>
                         </div>
                     </div>
                 </div>
             </section>

            {/*显示：彩屏妙用*/}
            <section className={styles.sectionColorScreen}>
                <div className={styles.sectionColorScreenRow1}>
                    <div>
                        <Text figmaStyle={"eyebrow"} label={'h2'}>
                            {/*显示*/}
                            {this.state.textData['text47'] ?? ''}
                        </Text>
                        <Text figmaStyle={"header-1"} label={'h3'} formatParam={{ strongClassName:styles.textStrongColorFul}}>
                            {/*{`{彩屏}妙用_细节更显`}*/}
                            {this.state.textData['text48'] ?? ''}
                        </Text>
                    </div>
                    <div className={styles.sectionColorScreenRow1Right}></div>
                </div>
                <div className={styles.sectionColorScreenRow2}>
                    <div className={styles.sectionColorScreenRow2Left}></div>
                    <div>
                        <Text figmaStyle={"body"} label={'p'} className={`${styles.sectionColorScreenInstruction}`} formatParam={{strongClassName:styles.sectionColorScreenRow2RightColorText}}>
                            {/*{`紧凑机身内嵌{1.22英寸中英双语彩屏}，轻松调节各项功能；尽享轻盈拍摄体验，至美影像一手掌握。`}*/}
                            {this.state.textData['text49'] ?? ''}
                        </Text>
                    </div>
                </div>

                <div className={styles.sectionColorScreenMediaContainer}>
                    {/*<Video*/}
                    {/*    autoplay={false}*/}
                    {/*    ref={videoColorScreenRef}*/}
                    {/*    className={`${styles.sectionColorScreenMediaImage}`}*/}
                    {/*    videoStyle={{ objectFit: 'cover' }}*/}
                    {/*    src={*/}
                    {/*        'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen.mp4'*/}
                    {/*    }*/}
                    {/*    source={[*/}
                    {/*        {*/}
                    {/*            src: 'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen.mp4',*/}
                    {/*            type: 'video/mp4',*/}
                    {/*        },*/}
                    {/*    ]}*/}
                    {/*    poster={*/}
                    {/*        'https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-cover.jpg'*/}
                    {/*    }*/}
                    {/*/>*/}
                    <ZyImage
                        className={`${styles.sectionColorScreenMediaImage}`}
                        src='https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-large.jpg'
                             sources={[
                                 {
                                     srcsets: [
                                         "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-medium.jpg",
                                         "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-medium@2x.jpg",
                                     ],
                                     media: "(max-width:1024px)",
                                 },
                                 {
                                     srcsets: [
                                         "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-small.jpg",
                                         "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-small@2x.jpg",
                                     ],
                                     media: "(max-width:768px)",
                                 },
                                 {
                                     srcsets: [
                                         "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-large.jpg",
                                         "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-screen-large@2x.jpg",
                                     ],
                                 },
                             ]} />
                </div>

            </section>
        </div>
            {/*续航、充电*/}
            <section className={styles.section12}>
                <div className={styles.section12InnerContainer}>
                    <div className={styles.section12Left}>
                        <div className={styles.section12LeftTextContainer1} id={'section12LeftTextContainer1'}>
                            <Text figmaStyle={"eyebrow"} label={'h2'}>
                                {/*续航*/}
                                {this.state.textData['text50'] ?? ''}
                            </Text>
                            <Text figmaStyle={"header-1"} label={'h3'} className={`${styles.section12Header1} ${styles.section12TextColorWhite}`}>
                                {/*{`电力无忧_从早拍到晚`}*/}
                                {this.state.textData['text51'] ?? ''}
                            </Text>
                            {
                                this.state.screenWidth<=1280 ?
                                    <div className={styles.section12Right2}>
                                        <ZyImage className={styles.section12Video} src={"https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-large.png"}
                                                 sources={[
                                                     {
                                                         srcsets: [
                                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-medium.png",
                                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-medium@2x.png",
                                                         ],
                                                         media: "(max-width:1024px)",
                                                     },
                                                     {
                                                         srcsets: [
                                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-small.png",
                                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-small@2x.png",
                                                         ],
                                                         media: "(max-width:768px)",
                                                     },
                                                     {
                                                         srcsets: [
                                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-large.png",
                                                             "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-large@2x.png",
                                                         ],
                                                     },
                                                 ]} />
                                    </div>
                                    : null
                            }
                            <Text figmaStyle={"body"} label={'p'} className={`${styles.section12Instruction}`} formatParam={{strongClassName:styles.section12TextColorWhite}}>
                                {/*{`稳定电力支持，轻松应对各种拍摄场景；{支持边充边用}，拍摄随心所欲，从容面对电量挑战，享受优雅摄影时光。`}*/}
                                {this.state.textData['text52'] ?? ''}
                            </Text>
                        </div>


                        <div className={styles.section12LeftTextContainer2} id={'section12LeftTextContainer2'}>
                            <Text figmaStyle={'section12-left-text-p1'} label={'p'}>
                                <strong>
                                    {/*支持*/}
                                    {this.state.textData['text53'] ?? ''}
                                </strong>
                            </Text>
                            <Text figmaStyle={'section12-left-text-p2'} label={'p'} className={styles.section12LeftTextP2} gradient={{
                                colors: [
                                    {
                                        color: "#52CC52",
                                        offset:"0%"
                                    },
                                    {
                                        color:"#52CC52",
                                        offset:"var(--section12-text-cover-width)"
                                    },
                                    {
                                        color: "#FFFFFF",
                                        offset:"var(--section12-text-cover-width)"
                                    },
                                ],
                            }}>
                                {/*PD快充*/}
                                {this.state.textData['text54'] ?? ''}
                            </Text>
                            <Text figmaStyle={'section12-left-text-p1'} label={'p'} className={styles.section12LeftTextP1Margin}><strong>
                                {/*续航时间长达*/}
                                {this.state.textData['text55'] ?? ''}
                            </strong></Text>
                            <Text figmaStyle={'section12-left-text-p2'} label={'p'} className={styles.section12LeftTextP2} gradient={{
                                colors: [
                                    {
                                        color: "#52CC52",
                                        offset:"0%"
                                    },
                                    {
                                        color:"#52CC52",
                                        offset:"var(--section12-text-cover-width)"
                                    },
                                    {
                                        color: "#FFFFFF",
                                        offset:"var(--section12-text-cover-width)"
                                    },
                                ],
                            }}>
                                {/*7.5小时*/}
                                {this.state.textData['text56'] ?? ''}
                            </Text>
                            <Text figmaStyle={'section12-left-text-p1'} label={'p'} className={styles.section12LeftTextP1Margin}><strong>
                                {/*充满100%仅需*/}
                                {this.state.textData['text57'] ?? ''}
                            </strong></Text>
                            <Text figmaStyle={'section12-left-text-p2'} label={'p'} className={styles.section12LeftTextP2} gradient={{
                                colors: [
                                    {
                                        color: "#52CC52",
                                        offset:"0%"
                                    },
                                    {
                                        color:"#52CC52",
                                        offset:"var(--section12-text-cover-width)"
                                    },
                                    {
                                        color: "#FFFFFF",
                                        offset:"var(--section12-text-cover-width)"
                                    },
                                ],
                            }}>
                                {/*2小时*/}
                                {this.state.textData['text58'] ?? ''}
                            </Text>
                            <Text figmaStyle={"note"} label={'p'} className={`${styles.section12Note}`}>
                                {/*{`*支持PD快充协议，峰值功率测试达12W，最快2小时充满电池。_以上数据来源于智云实验室标准环境测试所得，实际充电和续航时间略有差异。`}*/}
                                {this.state.textData['text60'] ?? ''}
                            </Text>
                        </div>
                    </div>
                    {
                        this.state.screenWidth>1280 ?
                            <div className={styles.section12Right}>
                                <ZyImage className={styles.section12Video} src={"https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-large.png"}
                                         sources={[
                                             {
                                                 srcsets: [
                                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-medium.png",
                                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-medium@2x.png",
                                                 ],
                                                 media: "(max-width:1024px)",
                                             },
                                             {
                                                 srcsets: [
                                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-small.png",
                                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-small@2x.png",
                                                 ],
                                                 media: "(max-width:768px)",
                                             },
                                             {
                                                 srcsets: [
                                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-large.png",
                                                     "https://bucket.zhiyun-tech.com/detail/crane-m3s/m3s-charge-large@2x.png",
                                                 ],
                                             },
                                         ]} />
                            </div>
                            :null
                    }
                </div>
            </section>
            {/*<section style={{height:'100vh',width:'100vw',backgroundColor:'#c03939'}}></section>*/}
        </>);
    }
}

export default CraneM3S;
